import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';
import { faqItems } from '../../data/mock';

const FAQSection = () => {
  return (
    <section id="faq" className="py-32 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-[#121212]" />
      
      <div className="relative max-w-4xl mx-auto px-6 lg:px-[7.6923%]">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-[#00FFD1] text-sm font-medium tracking-wider uppercase">FAQ</span>
          <h2 className="text-4xl md:text-5xl font-semibold text-white mt-4 leading-tight">
            Questions? Answers.
          </h2>
        </div>
        
        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqItems.map((item, index) => (
            <AccordionItem 
              key={index} 
              value={`item-${index}`}
              className="bg-[#000000] border border-white/10 px-6 data-[state=open]:border-[#00FFD1]/40 transition-all duration-300"
            >
              <AccordionTrigger className="text-white text-lg font-medium hover:no-underline hover:text-[#00FFD1] py-6 [&>svg]:text-[#00FFD1]">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-white/60 text-base leading-relaxed pb-6">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
